import SampleReportView from "@/components/samples/SampleReportView";
import { DSD_RENEWABLES_REPORT } from "@/data/sample-reports";

const DsdRenewablesSample = () => <SampleReportView report={DSD_RENEWABLES_REPORT} />;

export default DsdRenewablesSample;
